import type { AxiosError } from 'axios';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { editorService } from '../../services';

export function useFloorUsageTags(
    options?: UseQueryOptions<FloorUsageTag[], AxiosError, FloorUsageTag[], ['floor-usage-tags']>
): UseQueryResult<FloorUsageTag[]> {
    return useQuery(['floor-usage-tags'], () => editorService.getFloorUsageTags(), options);
}
